import { render } from "./ProfileDetails.vue?vue&type=template&id=1fb92569"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"

import "./ProfileDetails.vue?vue&type=style&index=0&id=1fb92569&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__